  ul {
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    color: var(--sl-color-neutral-500);
  }

  ul.compact {
    display: flex;
  }

  ul:not(.compact) {
    display: grid;
    grid-gap: var(--sl-spacing-x-small);
    grid-auto-flow: column;
    grid-auto-columns: min-content;
  }

  button {
    all: unset;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .currentPage {
    display: flex;
    align-items: center;
    width: fit-content;
    white-space: nowrap;
  }

  .pageInput {
    position: relative;
    margin-right: 0.5ch;
  }

  /* Use width of text to determine input width */
  .totalPages {
    /* Match the height of '<btrix-inline-input size="small">' */
    --sl-input-height-small: var(--sl-font-size-x-large);
    padding: 0 1ch;
    height: var(--sl-input-height-small);
    min-width: 1ch;
    visibility: hidden;
  }

  .input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .navButton {
    display: grid;
    grid-template-columns: repeat(2, min-content);
    grid-gap: var(--sl-spacing-x-small);
    margin: 0 var(--sl-spacing-x-small);
    align-items: center;
    font-weight: 500;
    transition: opacity 0.2s;
    min-height: 1.5rem;
    min-width: 1.5rem;
    user-select: none;
  }

  .navButton[disabled] {
    opacity: 0.4;
  }

  .navButton:not([disabled]):hover {
    opacity: 0.8;
  }

  .chevron {
    display: block;
    width: var(--sl-spacing-medium);
    height: var(--sl-spacing-medium);
  }

  .compact .navButton {
    display: flex;
    justify-content: center;
  }
